import { Radio } from 'components/common';

const VoiceSetting = ({ selectedLocale, updateLocale, filteredLocaleList, filteredCurrentLocale }: any) => {

  return (
    <div className="flex h-full flex-col">
      <div className="sticky top-0 flex items-center gap-3 pt-5 pb-4 bg-base-bg-strong w-full">
        <Radio name="languageGroup" value={selectedLocale} isChecked={true} readOnly />
        <span className="typography-headline-sm text-base-txt-primary">{filteredCurrentLocale}</span>
      </div>
      <div className="h-full flex-1 overflow-y-auto">
        {filteredLocaleList.map((item: any) => (
          <li data-locale={item.locale} key={item.lang} className="list-none">
            <label className="flex items-center gap-3 py-5">
              <Radio name="languageGroup" value={item.lang} isChecked={selectedLocale === item.lang} onChange={() => updateLocale(item.locale)} />
              <span className="typography-body-sm text-base-txt-secondary">{item.lang}</span>
            </label>
          </li>
        ))}
      </div>
    </div>
  );
};
export default VoiceSetting;
